import React from "react";
import { ModalBody, Modal } from "reactstrap";
import styles from "./Invited.module.scss";

const Invited = ({ openModal, toggle }) => {
  return (
    <Modal
      isOpen={openModal}
      toggle={() => {
        toggle();
      }}
      centered
      fullscreen="sm"
      contentClassName={styles["modal_content"]}
      className={styles["container"]}
      wrapClassName={styles["modal_wrapper"]}
      backdropClassName={styles["modal-backdrop-style"]}
    >
      <ModalBody className={styles["modal_body"]}>
        <div>
          <p className={styles["heading"]}>Your admin invite has been sent.</p>
          <p className={styles["descriptiondiv"]}>
            The recipient will have 24 hours to click the link in their email to
            activate their account.
          </p>
        </div>
        <div className={styles["button-container"]}>
          <button onClick={() => toggle()} className={styles["button"]}>
            Okay
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default Invited;
